
(function () {
    const configurations = {
        'trackingActive': process.env.NODE_ENV == 'production' ? true : false,
        'doubleClickDebug': false,
        'options': [],
        'activeModule': [
            {
                'name': 'TickModule',
                'options': {
                    "tickactive": false,
                    "tickInterval": 1000,

                },
            },
            {
                'name': 'TimeTrackingModule',
                'options': [],
            },
            {
                'name': 'ClickedElementTrackingModule',
                'options': [],
            },
            {
                'name': 'MousePositionTrackingModule',
                'options': [],
            },
            {
                //aktuell nicht individuell, siehe arrowkey
                'name': 'NavigationKeysTrackingModule',
                'options': {
                    'keys': {
                        'arrowKeys': true,
                    },
                },
            },
            {
                'name': 'ScrollTrackingModule',
                'options': [
                    {
                        'observed_elements_and_areas': [
                            // Star,-End Element per "Copy-Selector"

                            {
                                'name': 'Paywall',
                                'startElementSelector': '.text-center.text-lg.sm\\:text-xl.text-neutral-60.font-medium.mb-8',
                                'endElementSelector': '#paywall_login > form > button'
                            },
                            {
                                'name': 'Mehr zu diesem Thema',
                                'startElementSelector': '#newsliste > div.flex.justify-between.xmd\\:block.rounded-0.sm\\:rounded-t.bg-linear-to-br.from-skin-brand.from-10\\%.to-brandGradient-dark.to-100\\%.mt-20.px-5.pt-4.pb-3.xmd\\:px-11.xmd\\:pt-7.xmd\\:pb-6 > h2 > a',
                                'endElementSelector': '#id_inner_81699e03-c279-4a47-bcaf-b49b1cd5c5b2 > div > div > div.flex-1.flex.flex-col.justify-between > div.flex.justify-end.p-5.bg-neutral-3.border-t.border-neutral-10.xmd\\:rounded-br'
                            },
                            {
                                'name': 'Heft-Reader',
                                'startElementSelector': 'body > main > section > div.iww-teaser-container__title.sm\\:h-20.sm\\:flex.items-center.rounded-0.sm\\:rounded-t.bg-linear-to-br.from-skin-brand.from-10\\%.to-brandGradient-dark.to-100\\%.px-6.sm\\:px-11.py-4.sm\\:py-0 > span',
                                'endElementSelector': '#newsliste > div > div.flex-1.flex.flex-col.justify-between.relative > div.items-center.flex.justify-end.flex-wrap.border-t.w-full.py-8.px-6.sm\\:px-11, #newsliste > div > div.flex-1.flex.flex-col.justify-between.relative > div.items-center.flex.justify-end.flex-wrap.border-t.w-full.py-6.px-6.sm\\:px-11'
                            },
                        ]
                    }

                ],
            },
            {
                'name': 'WindowSizeTrackingModule',
                'options': [],
            }
        ]
    };

    document.addEventListener('DOMContentLoaded', function () {
        if (configurations.trackingActive === true) {
            let trackingObjekt = new FrontendTracking(configurations);
            trackingObjekt.bootstrap(configurations);
        } else {
            console.log('Deaktiviert');
        }
    });
})();
class FrontendTracking {
    constructor(config) {
        this.configuration = config;
        this.activeModules = [];
        this.DataRecorderInstance = new DataRecorder(this.syncLocalStorage.bind(this));
        this.tickModule = null;

        //ErrorCollector, spätere Integration
        this.errorCollection = [];
        this.flush();
    }
    bootstrap() {
        const tickModulConfig = this.configuration.activeModule.find(module => module.name === 'TickModule');
        if (tickModulConfig && tickModulConfig.options) {
            this.tickModule = new TickModule(tickModulConfig.options);
        } else {
            console.warn('TickModul-Konfiguration nicht gefunden.');
        }
        this.createModules();
        if (this.configuration.doubleClickDebug) this.consoleDebuggerFunction();

        this.listenToOnBeforeUnload();
    }

    createModules() {

        const moduleClasses = {
            TimeTrackingModule: TimeTrackingModule,
            ClickedElementTrackingModule: ClickedElementTrackingModule,
            MousePositionTrackingModule: MousePositionTrackingModule,
            NavigationKeysTrackingModule: NavigationKeysTrackingModule,
            ScrollTrackingModule: ScrollTrackingModule,
            WindowSizeTrackingModule: WindowSizeTrackingModule
        };

        const errorInformations = [];
        try {
            if (this.configuration && Array.isArray(this.configuration.activeModule)) {
                this.configuration.activeModule.forEach((configModul) => {
                    try {
                        const ModulClass = moduleClasses[configModul.name];
                        if (ModulClass) {
                            this.buildModule(ModulClass, configModul.options);
                        } else {
                            throw new Error(`Modulklasse für ${configModul.name} nicht gefunden.`);
                        }
                    } catch (innerE) {

                        errorInformations.push({
                            error: 'Modulaktivierung fehlgeschlagen.',
                            modulname: configModul.name,
                            errorMessage: innerE.message || innerE,
                            stackTrace: innerE.stack || 'Kein Stacktrace verfügbar'
                        });
                    }
                });
            } else {
                errorInformations.push({
                    error: 'ModulConfig-Fehler',
                    errorMessage: 'configuration.activeModule ist ungültig oder nicht definiert.'
                });
            }
        } catch (E) {
            console.error('Fehler beim Durchlaufen der Konfiguration: ', E);
        } finally {
            if (errorInformations.length > 0) {
                this.errorCollection.push({ 'ModulCreate-Error': errorInformations });
            }
        }
    }

    buildModule(ModulClass, options) {
        const modulInstace = new ModulClass(options, this.DataRecorderInstance, this.tickModule);
        modulInstace.register();
        this.activeModules.push(modulInstace);
    }

    listenToOnBeforeUnload() {
        window.onbeforeunload = () => {
            this.sendToApiViaBeacon(this.DataRecorderInstance.getData());
            //this.sendToApi(this.DataRecorderInstance.getData());
        };
    }
    setDataInLocalStorage() {
        const reacordData = JSON.stringify(this.DataRecorderInstance.getData());
        localStorage.setItem('safeForm', reacordData);
    }

    syncLocalStorage() {
        this.setDataInLocalStorage();
    }

    flush() {
        const errorInformations = [];

        const savedData = localStorage.getItem('safeForm');

        if (savedData) {
            try {
                const storageObjektJSON = JSON.parse(savedData);

                if (storageObjektJSON.uuid !== this.DataRecorderInstance.safeForm.uuid &&
                    storageObjektJSON.modulData &&
                    storageObjektJSON.modulData.length > 0
                ) {

                    //this.sendToApi(storageObjektJSON);
                    this.sendToApiViaBeacon(storageObjektJSON);
                    this.clearLocalStorage();
                }
            } catch (parseError) {

                errorInformations.push({
                    error: "Fehler beim Senden der LocalStorage-Daten.",
                    errorMessage: parseError.message,
                    stackTrace: parseError.stack || 'Kein Stacktrace verfügbar'
                });
            }
        }
        if (errorInformations.length > 0) {
            this.errorCollection.push({ 'Flush-Error': errorInformations });
        }
    }


    sendToApiViaBeacon(dataRecord) {
        const readyApiForm = {
            "resource": this.DataRecorderInstance.getReadyForApi(dataRecord)
        };

        const FormDataJSON = JSON.stringify(readyApiForm);
        const blob = new Blob([FormDataJSON], { type: 'application/json' });

        const url = process.env.TRACKING_URL;

        const beaconResult = navigator.sendBeacon(url, blob);

        if (!beaconResult) {
            this.setDataInLocalStorage();
        }
    }
    sendToApi(dataRecord) {
        const FormForApi = {
            "resource": this.DataRecorderInstance.getReadyForApi(dataRecord)
        };

        const errorInformations = [];

        fetch(
            process.env.TRACKING_URL,
            {
                method: "POST",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(FormForApi)
            })

            .then(response => {
                if (!response.ok) {
                    errorInformations.push({
                        error: 'Netzwerkantwort war nicht ok.',
                        status: response.status,
                        statusText: response.statusText
                    });
                    throw new Error('Netzwerkantwort war nicht ok.');
                }
                return response.json();
            })

            .then(data => {
                console.log('Erfolg! Diese Daten wurde abgeschickt und werden aus dem localStorage gelöscht', data);
                localStorage.removeItem("safeForm");
            })

            .catch((error) => {
                if (error instanceof TypeError && error.message.includes('NetworkError')) {
                    // Fetch - Fehler zum FehlerArray hinzufügen;
                    errorInformations.push({
                        error: 'Cors / Netzwerkfeler beim Senden der Daten an die API',
                        errorMessage: error.message,
                        stackTrace: error.stack || 'Kein Stacktrace verfügbar'
                    });
                } else {
                    errorInformations.push({
                        error: 'Fehler beim Senden der Daten an die API',
                        errorMessage: error.message,
                        stackTrace: error.stack || 'Kein Stacktrace verfügbar'
                    });
                }
                this.setDataInLocalStorage();
            })
            .finally(() => {
                if (errorInformations.length > 0) {
                    this.errorCollection.push({ 'Fetch-Error': errorInformations });
                }
            });
    }
    clearLocalStorage() {
        localStorage.removeItem("safeForm");
    }

    //Rückgabe der Error, nicht vollständig Integiert
    getCollectedErrors() {
        return this.errorCollection;
    }
    getAllTrackingsStatsInConsole() {
        console.log("===============Tracking-Daten==================");
        this.activeModules.forEach((module) => {
            if (typeof module.getDataInConsole === 'function') {
                module.getDataInConsole();
            }
        });
        console.log("===============================================");
    }
    consoleDebuggerFunction() {
        document.addEventListener('dblclick', () => {
            this.getAllTrackingsStatsInConsole();
            this.DataRecorderInstance.getData();
            //Nicht vollständig implimentiert
            this.getCollectedErrors();
            //this.sendToApi(this.DataRecorderInstance.getData());
            console.log("Daten noch nicht gesichert.");
        });
    }

}
class TickModule {
    constructor(options) {
        this.options = options;
        this.tickInterval = options.tickInterval || 2000;
        this.listeningModules = [];
        this.tabActive = null;
    }
    register(module) {
        typeof module.tick === 'function' && this.listeningModules.push(module);
        this.pauseWhenInactive();
        this.options.tickactive && this.start();
    }
    start() {
        this.tabActive = true;
        setInterval(() => {
            this.triggerEventsInListeningModules();
        }, this.tickInterval
        );
    }
    triggerEventsInListeningModules() {
        if (this.tabActive === true) {
            this.listeningModules.forEach((module) => {
                module.tick();
            });
        }

    }
    pauseWhenInactive() {
        document.addEventListener("visibilitychange", () => {
            this.tabActive = !document.hidden;
        });
    }
}
class TimeTrackingModule {

    //Performance hier nochmal anschauen
    constructor(options, dataRecorderInstance) {
        this.options = options;
        this.settings = [];
        this.dataRecorder = dataRecorderInstance;

        this.activeTimerStart = Date.now();
        this.activeTimeSpend = 0;

        this.start = Date.now();
        this.end = null;
        this.timeSpend = null;

        window.addEventListener('beforeunload', () => this.ensureFinalActiveTime());
    }
    register() {
        this.listenForStatusChange();
    }

    listenForStatusChange() {
        document.addEventListener('visibilitychange', () => {
            this.countDependingOnStatus(document.visibilityState);
        });
    }
    countDependingOnStatus(status) {
        if (status === 'visible' && this.activeTimerStart === null) {
            this.activeTimerStart = Date.now();
        } else if (status === 'hidden') {
            this.addActiveTime();
        }
    }

    calculatTime() {
        this.end = Date.now();
        this.timeSpend = (this.end - this.start);
        return this.timeSpend;
    }

    addActiveTime() {
        if (this.activeTimerStart !== null) {
            this.activeTimeSpend += Date.now() - this.activeTimerStart;
            this.activeTimerStart = null;
        }
    }
    ensureFinalActiveTime() {
        this.safeData();
    }
    getDataInConsole() {
        this.calculatTime();
        this.addActiveTime();
        console.log("Time Tracker: ", [
            {
                'startTime': Math.floor(this.start / 1000),
                'endTime': Math.floor(this.end / 1000),
                'timeOnSide': Math.floor(this.timeSpend / 1000),
                'activeTimeOnSide': Math.floor(this.activeTimeSpend / 1000)
            }]

        );
        this.safeData();
    }
    safeData() {

        this.calculatTime();
        this.addActiveTime();

        const timeTrackerRecord = {
            'startTime': Math.floor(this.start / 1000),
            'endTime': Math.floor(this.end / 1000),
            'timeOnSide': Math.floor(this.timeSpend / 1000),
            'activeTimeOnSide': Math.floor(this.activeTimeSpend / 1000)
        };

        this.dataRecorder.addData({
            'modulname': 'TimerTrackerModul',
            'data': timeTrackerRecord
        });
    }
}
class ClickedElementTrackingModule {
    constructor(options, dataRecorderInstance) {
        this.options = options;
        this.dataRecorder = dataRecorderInstance;
        this.clickedItems = [];
        this.clickedLink = null;
    }
    register() {
        this.getClickElememtInfo();
    }


    getClickElememtInfo() {
        document.addEventListener('click', (event) => {

            const element = event.target;
            const xpath = getXPath(element);
            this.clickedLink = getClickedLink(element)
            this.clickedItems.push({ 'clickedXpath': xpath, 'timestamp': Date.now()});

            this.safeData();
        });
        function getXPath(element) {

            if (element.id) {
                return `//*[@id="${element.id}"]`;
            }

            const parts = [];
            while (element && element.nodeType === Node.ELEMENT_NODE) {
                let index = 1;
                let sibling = element.previousSibling;

                while (sibling) {
                    if (sibling.nodeType === Node.ELEMENT_NODE && sibling.nodeName === element.nodeName) {
                        index++;
                    }
                    sibling = sibling.previousSibling;
                }

                const tagName = element.nodeName.toLowerCase();
                const pathIndex = `[${index}]`;
                parts.unshift(`${tagName}${pathIndex}`);
                element = element.parentNode;
            }
            return `/${parts.join('/')}`;
        }

        function getClickedLink(element) {
            const a = element.closest?.("a[href]");
            return a ? a.href : null;
        }
    }

    getDataInConsole() {
        console.log("Clicked-Items:", this.clickedItems, "clickedLink:", this.clickedLink);
    }

    safeData() {
        const data = { xpaths: this.clickedItems };
        if (this.clickedLink) data.clickedLink = this.clickedLink;

        this.dataRecorder.addData({
            modulname: 'ClickedElementModul',
            data
        });
    }
}
class MousePositionTrackingModule {
    constructor(options, dataRecorderInstance, tickModul) {
        this.options = options;
        this.dataRecorder = dataRecorderInstance;
        this.mouseCoordinates = [];
        this.currentMouseCoordinates = { 'x': 0, 'y': 0, 'timestamp': Date.now() };

        document.addEventListener('mousemove', (event) => {
            this.currentMouseCoordinates = {
                'x': event.pageX,
                'y': event.pageY,
                'timestamp': Date.now()
            };
        });
        this.tickModul = tickModul;
    }

    register() {
        this.tickModul && this.tickModul.register(this);
    }
    tick() {
        this.mouseCoordinates.push({ ...this.currentMouseCoordinates });
        this.safeData();
    }
    getDataInConsole() {
        console.log("Click-Maus-Positions", this.mouseCoordinates);
    }
    safeData() {
        this.dataRecorder.addData({
            'modulname': 'MousePositionModul',
            'data': { "mousepositions": this.mouseCoordinates }
        });
    }
}
class DataRecorder {
    constructor(sync) {
        this.syncLocalStorage = sync;
        this.safeForm = {
            'uuid': this.generateUUID(),
            'modulData': [],
            'creatDate': Math.floor(Date.now() / 1000),
            'url': window.location.href,
        };
    }
    generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    addData(moduldataset) {
        const existingModul = this.safeForm['modulData'].find(
            (module) => module.modulname === moduldataset.modulname
        );
        existingModul
            ? existingModul.data = moduldataset.data
            : this.safeForm['modulData'].push(moduldataset);

        this.syncLocalStorage();
    }
    getData() {
        return this.safeForm;
    }

    getReadyForApi(dataRecord) {
        return {
            type: "tracking",
            version: 1,
            timestamp: Math.floor(Date.now() / 1000),
            content: dataRecord
        };
    }
}
class NavigationKeysTrackingModule {
    constructor(options, dataRecorderIntance) {
        this.options = options;
        this.dataRecorder = dataRecorderIntance;
        this.pressedNavKeys = [];
    }
    register() {
        this.observeNavigateKeys();
    }
    observeNavigateKeys() {
        document.addEventListener('keydown', (event) => {
            const keyMap = {
                'Tab': event.shiftKey ? 'Shift + Tab' : 'Tab',
                'ArrowUp': 'ArrowUp',
                'ArrowDown': 'ArrowDown',
                'ArrowLeft': 'ArrowLeft',
                'ArrowRight': 'ArrowRight',
                ' ': 'Space',
                'Spacebar': 'Space',
                'PageUp': 'PageUp',
                'PageDown': 'PageDown',
                'Home': 'Home',
                'End': 'End'
            };

            const mappedKey = keyMap[event.key];
            if (mappedKey) {
                this.pressedNavKeys.push({ key: mappedKey });
                this.safeData();
            }
        });


    }
    getDataInConsole() {
        console.log("Used Navigate-Keys", this.pressedNavKeys);
    }

    safeData() {
        this.dataRecorder.addData({
            'modulname': 'NavigationKeysTrackingModul',
            'data': {
                'keys': this.pressedNavKeys,
            }
        });
    }
}
class ScrollTrackingModule {
    constructor(options, dataRecorderInstance) {
        this.options = options;
        this.dataRecorder = dataRecorderInstance;
        this.scrollPercentage = 0;
        this.start = window.scrollY;
        this.max = 0;
        this.sideDepth = document.documentElement.scrollHeight;
        this.watchlist = [];
        this.handleObserver = this.handleObserver.bind(this);

    }
    register() {
        this.iniTrackElementsFromConfig();
        this.observeScrolling();
        this.observeContentElements(this.watchlist);
    }

    iniTrackElementsFromConfig() {
        if (this.options[0].observed_elements_and_areas) {
            this.options[0].observed_elements_and_areas.forEach((element) => {
                const startExists = document.querySelector(element.startElementSelector);
                const endExists = document.querySelector(element.endElementSelector);

                if (startExists && endExists) {
                    this.watchlist.push({
                        name: element.name,
                        start: element.startElementSelector,
                        end: element.endElementSelector,
                        startVisible: false,
                        endVisible: false,
                        fullySeen: false,
                        state: 'not_seen'
                    });
                } else {
                    //console.log("Nicht gefunden")
                }
            });
        }
    }


    observeScrolling() {
        let scrollTimeout;
        document.addEventListener('scroll', () => {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
                const maxScrollDepth = document.documentElement.scrollHeight - window.innerHeight;
                const currentScrollDepth = window.scrollY;

                const newPercentage = ((currentScrollDepth / maxScrollDepth) * 100).toFixed(2);
                const newMax = parseInt(window.scrollY.toFixed(2));

                if (this.scrollPercentage < newPercentage) this.scrollPercentage = newPercentage;
                if (this.max < newMax) this.max = newMax;

                this.safeData();
            }, 200);
        });
    }


    handleObserver(entry, indexOfElement) {

        const startElement = document.querySelector(this.watchlist[indexOfElement].start);
        const endElement = document.querySelector(this.watchlist[indexOfElement].end);

        if (!startElement || !endElement) return;

        if (entry.isIntersecting) {
            if (entry.target === startElement && !this.watchlist[indexOfElement].startVisible) {
                this.watchlist[indexOfElement].startVisible = true;
                this.watchlist[indexOfElement].state = 'see_partially';
            }

            if (entry.target === endElement && !this.watchlist[indexOfElement].endVisible) {
                this.watchlist[indexOfElement].endVisible = true;

                if (!this.watchlist[indexOfElement].fullySeen) {
                    this.watchlist[indexOfElement].fullySeen = true;
                    this.watchlist[indexOfElement].state = 'fully_seen';
                }
            }
        } else {
            //console.log("Element nicht im Sichtbereich:", entry.target);
        }
    }

    observeContentElements(watchlist) {
        const options = {
            root: null,
            rootMargin: "0px",
            threshold: [0.99, 1]
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const index = entry.target.getAttribute('data-index');
                if (index !== null) {
                    this.handleObserver(entry, index);
                }
            });
        }, options);

        watchlist.forEach((element, indexOfElement) => {
            const startElement = document.querySelector(element.start);
            const endElement = document.querySelector(element.end);

            if (startElement) {
                startElement.setAttribute('data-index', indexOfElement);
                startElement.setAttribute('position', 'start');
                observer.observe(startElement);
            } else {
                //console.log(`Start-Element nicht gefunden: ${element.start}`);
            }

            if (endElement) {
                endElement.setAttribute('data-index', indexOfElement);
                endElement.setAttribute('position', 'end');
                observer.observe(endElement);
            } else {
                //console.log(` End-Element nicht gefunden: ${element.end}`);
            }
        });
    }


    getDataInConsole() {
        console.log("Scroll & Element Tracker: ", [{
            'modulname': 'ScrollTrackingModul',
            'data': {
                'scrolledPercentage': this.scrollPercentage,
                'sidedepth': this.sideDepth,
                'trackedElements': this.watchlist

            }
        }]);
    }
    safeData() {
        this.dataRecorder.addData({
            'modulname': 'ScrollTrackingModul',
            'data': {
                //'start_Y' : this.start,
                //'end_Y' : this.max,
                'scrolledPercentage': this.scrollPercentage,
                'sidedepth': this.sideDepth,
                'trackedElements': this.watchlist
            }
        });
    }

}
class WindowSizeTrackingModule {
    constructor(options, dataRecorderInstace) {
        this.options = options;
        this.dataRecorder = dataRecorderInstace;
        this.startedWindowSize = { 'height': window.innerHeight, 'width': window.innerWidth };
        this.windowSizeChanged = [];
        this.resizeTimeout = null;
    }
    register() {
        this.safeData();
        this.observeWindowSizeChanges();
    }

    observeWindowSizeChanges() {
        window.addEventListener('resize', () => {
            clearTimeout(this.resizeTimeout);
            //neuen timer setzen in der hoffnung das er jetzt durchläuft
            this.resizeTimeout = setTimeout(() => {
                // wenn durchgelaufen, speichern
                this.currentWindowSize = {
                    height: window.innerHeight,
                    width: window.innerWidth,
                    timestamp: Date.now()
                };
                this.windowSizeChanged.push(this.currentWindowSize);
                this.safeData();
            }, 1000);
        });
    }
    getDataInConsole() {
        console.log("Initial Window Size: ", [this.startedWindowSize]);
        console.log("Window Size Changes: ",
            this.windowSizeChanged.length === 0 ? [] : [this.windowSizeChanged]
        );

    }

    safeData() {
        this.dataRecorder.addData(
            {
                'modulname': 'WindowSizeTrackingModul',
                'data': {
                    'startedHeight': this.startedWindowSize.height,
                    'startedWidth': this.startedWindowSize.width,
                    'changedSizes': this.windowSizeChanged
                }
            }
        );
    }
}
